export default {
  routes: [
    /*  登录页 */
    {
      path: "/",
      name: "Login",
      meta: {
        auth: true,
      },
      component: () => import("@/view/login/index.vue"),
    },
    //听音乐区
    {
      path: "listenMusic",
      name: "ListenMusic",
      component: () =>
        import("@/view/listenMusic/index.vue"),
    },
    /* 管理端 */
    {
      path: "/management",
      name: "Management",
      component: () => import("@/view/management/index.vue"), //导航
      // redirect: "/management/supAdmin", //重定向到第一个子路由
      children: [
        /* 欢迎页*/
        {
          path: "welcome",
          name: "Welcome",
          component: () => import("@/view/management/welcome/index.vue"),
        },
        // {
        //   path: "dashboard",
        //   name: "Dashboard",
        //   component: () =>
        //     import("@/view/management/supAdmin/dashboard/index.vue"),
        // },
        /* 超级管理员-管理账号权限 */
        {
          path: "system",
          name: "System",
          component: () => import("@/view/management/system/index.vue"),
          children: [{
            path: "user",
            name: "SysUser",
            component: () =>
              import("@/view/management/system/user/index.vue"),
          },
          {
            path: "authGroup",
            name: "AuthGroup",
            component: () =>
              import("@/view/management/system/authGroup/index.vue"),
          },
          ],
        },
        //工作区
        {
          path: "workspace",
          name: "Workspace",
          component: () =>
            import("@/view/management/workspace/index.vue"),
        },
        //商家-管理账号权限
        {
          path: "myPermission",
          name: "MyPermission",
          component: () => import("@/view/management/myPermission/index.vue"),
          children: [{
            path: "user",
            name: "MyPermissionUser",
            component: () =>
              import("@/view/management/myPermission/user/index.vue"),
          },
          {
            path: "authGroup",
            name: "MyPermissionAuthGroup",
            component: () =>
              import("@/view/management/myPermission/authGroup/index.vue"),
          },
          ],
        },
        {
          path: "mini",
          name: "Mini",
          component: () =>
            import("@/view/management/mini/index.vue"),
          children: [
            {
              path: "dashboard",
              name: "MiniDashboard",
              component: () =>
                import("@/view/management/mini/dashboard/index.vue"),
            }, {
              path: "order",
              name: "MiniOrder",
              component: () =>
                import("@/view/management/mini/order/index.vue"),
            },
            {
              path: "store",
              name: "MiniStore",
              component: () =>
                import("@/view/management/mini/store/index.vue"),
            },
            {
              path: "user",
              name: "MiniUser",
              component: () =>
                import("@/view/management/mini/user/index.vue"),
            },
            {
              path: "vipCard",
              name: "MiniVipCard",
              component: () =>
                import("@/view/management/mini/vipCard/index.vue"),
            },
            {
              path: "vipCardRecode",
              name: "MiniVipCardRecode",
              component: () =>
                import(
                  "@/view/management/mini/vipcardRecode/index.vue"
                ),
            },
          ],
        },
        {
          path: "plus",
          name: "Plus",
          component: () =>
            import("@/view/management/plus/index.vue"),
          children: [
            {
              path: "dashboard",
              name: "PlusDashboard",
              component: () =>
                import("@/view/management/plus/dashboard/index.vue"),
            }, {
              path: "order",
              name: "PlusOrder",
              component: () =>
                import("@/view/management/plus/order/index.vue"),
            },
            {
              path: "store",
              name: "PlusStore",
              component: () =>
                import("@/view/management/plus/store/index.vue"),
            },
            {
              path: "user",
              name: "PlusUser",
              component: () =>
                import("@/view/management/plus/user/index.vue"),
            },
            {
              path: "vipCard",
              name: "PlusVipCard",
              component: () =>
                import("@/view/management/plus/vipCard/index.vue"),
            },
            {
              path: "vipCardRecode",
              name: "PlusVipCardRecode",
              component: () =>
                import(
                  "@/view/management/plus/vipcardRecode/index.vue"
                ),
            },

          ],
        },
        {
          path: "mall",
          name: "Mall",
          component: () =>
            import("@/view/management/mall/index.vue"),
          children: [{
            path: "dashboard",
            name: "MallDashboard",
            component: () =>
              import("@/view/management/mall/dashboard/index.vue"),
          },
          {
            path: "order",
            name: "MallOrder",
            component: () =>
              import("@/view/management/mall/order/index.vue"),
          },
          {
            path: "store",
            name: "MallStore",
            component: () =>
              import("@/view/management/mall/store/index.vue"),
          },
          {
            path: "user",
            name: "MallUser",
            component: () =>
              import("@/view/management/mall/user/index.vue"),
          },
          ],
        },
        /* 我的门店管理 */
        {
          path: "myMall",
          name: "MyMall",
          component: () => import("@/view/management/myMall/index.vue"),
          children: [{
            path: "storeList",
            name: "MyMallStoreList",
            component: () =>
              import("@/view/management/myMall/storeList/index.vue"),
          },
          {
            path: "staff",
            name: "Staff",
            component: () =>
              import("@/view/management/myMall/staff/index.vue"),
          },
          {
            path: "bannerConfig",
            name: "MyMallBannerConfig",
            component: () =>
              import("@/view/management/myMall/bannerConfig/index.vue"),
          },
          {
            path: "coupon",
            name: "Coupon",
            component: () =>
              import("@/view/management/myMall/coupon/index.vue"),
          },
          {
            path: "goods",
            name: "Goods",
            component: () =>
              import("@/view/management/myMall/goods/index.vue"),
            children: [{
              path: "goodsKind",
              name: "GoodsKind",
              component: () =>
                import("@/view/management/myMall/goods/goodsKind/index.vue"),
            },
            {
              path: "goodsList",
              name: "GoodsList",
              component: () =>
                import("@/view/management/myMall/goods/goodsList/index.vue"),
            },
            ],
          },
          {
            path: "mallGoods",
            name: "MallGoods",
            component: () =>
              import("@/view/management/myMall/mallGoods/index.vue"),
            children: [{
              path: "goodsKind",
              name: "MallGoodsKind",
              component: () =>
                import(
                  "@/view/management/myMall/mallGoods/goodsKind/index.vue"
                ),
            },
            {
              path: "goodsList",
              name: "MallGoodsList",
              component: () =>
                import(
                  "@/view/management/myMall/mallGoods/goodsList/index.vue"
                ),
            },
            ],
          },
          {
            path: "integralGoods",
            name: "IntegralGoods",
            component: () =>
              import("@/view/management/myMall/integralGoods/index.vue"),
            children: [{
              path: "goodsKind",
              name: "IntegralGoodsKind",
              component: () =>
                import(
                  "@/view/management/myMall/integralGoods/goodsKind/index.vue"
                ),
            },
            {
              path: "goodsList",
              name: "IntegralGoodsList",
              component: () =>
                import(
                  "@/view/management/myMall/integralGoods/goodsList/index.vue"
                ),
            },
            ],
          },

          /* 会员管理 */
          {
            path: "vipCard",
            name: "MallVipCard",
            component: () => import("@/view/management/myMall/vipCard/index.vue"),
            children: [{
              path: "vipCardList",
              name: "MallVipCardList",
              component: () => import("@/view/management/myMall/vipCard/vipCardList"),
            },
            {
              path: "vipCardRecode",
              name: "MallVipCardRecode",
              component: () =>
                import("@/view/management/myMall/vipCard/vipCardRecode"),
            },
            ],
          },

          /* 门店会员订单 */
          {
            path: "order",
            name: "Order",
            component: () => import("@/view/management/myMall/order/index.vue"),
          },
          ],
        },

        /* 微信通知服务 */
        {
          path: "sendService",
          component: () => import("@/view/management/sendService/index.vue"),
          children: [
            // 基础配置（包含公众号配置和消息模版）
            {
              path: "baseConfig",
              name: "BaseConfig",
              component: () =>
                import("@/view/management/sendService/baseConfig/index.vue"),
            },
            // 用户列表（包含手动发送功能）
            {
              path: "userList",
              name: "UserList",
              component: () =>
                import("@/view/management/sendService/userList/index.vue"),
            },
            // 通知任务（包含时间周期、定时任务、手动发送）
            {
              path: "taskManage",
              name: "TaskManage",
              component: () =>
                import("@/view/management/sendService/taskManage/index.vue"),
            },
            // 发送记录（手动和自动发送的历史记录）
            {
              path: "recordList",
              name: "RecordList",
              component: () =>
                import("@/view/management/sendService/recordList/index.vue"),
            },
            {
              path: "doc",
              name: "SendDoc",
              component: () =>
                import("@/view/management/sendService/doc/index.vue"),
            },
          ],
        },

        /* 商家服务 */
        {
          path: "merchant",
          name: "Merchant",
          component: () => import("@/view/management/merchant/index.vue"),
          children: [{
            path: "payment",
            name: "Payment",
            component: () =>
              import("@/view/management/merchant/payment/index.vue"),
          },],
        },
        /* 个人页 */
        {
          path: "person",
          // name: "Person",
          component: () => import("@/view/management/person/index.vue"), //导航
          children: [{
            path: "center",
            name: "PersonCenter",
            component: () =>
              import("@/view/management/person/center/index.vue"),
          },],
        }
      ],
    },
    /* 其他页 */
    {
      path: "/error",
      name: "Error",
      component: () => import("@/view/error/index.vue"),
    },
  ],
  // mode: "history",
  mode: "hash",
};